import {
    apiRequest,
    anakDetail,
    anakApprove
} from "../../../../../../services/adapters/kepegawaian/anakService"

class ApproveRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", anakDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", anakApprove, {
            body: query
        }, true)
    }
}

export default ApproveRepository